/**
 * Marquee Component
 */
export class Marquee {
    constructor() {
        // 기존 initMarquee 로직 유지
        if (typeof initMarquee === 'function') {
            initMarquee();
        }
    }
}

